import $ from 'jquery';
import '@fancyapps/fancybox';
import '../vendors/detectmobilebrowser';
import Registry from "./Registry";
import BannerCookie from "../utils/banner-cookie";
import SmoothScroll from "smooth-scroll";
import {$Doc} from "../utils/jQueryGlobals";

export default class Context {
  constructor() {
    this.loadComponents();
    this.defaultContext();
  }

  defaultContext() {
    new BannerCookie();

    this.scroll = new SmoothScroll('a[href*="#"]', {
      ignore: '[data-scroll-ignore]',
      speed: 800,
      durationMax: 1000,
      durationMin: 200,
      easing: 'easeInOutCubic',
    });

    this.header = $('#header');
    $Doc.on('scrollStart', () => {
      this.header.removeClass('open').find('.hamburger').removeClass('is-active');
    });

    $(() => {
      $('.rte table').wrap('<div class="responsive-table" />');
      if (window._gTheme_.field_subject) {
        $('#contact-subject').val(window._gTheme_.field_subject);
      }
    });
  }

  loadComponents(name = false, context) {
    let registry = new Registry(),
      selector = '[data-g-component]';
    if (name) {
      selector = '[data-g-component="' + name + '"]';
    }
    $(selector, context).each((index, elem) => {
      if (!$(elem).data('g-component-initialized')) {
        let Cmp = registry.getComponent($(elem).data('g-component'));
        if (typeof Cmp === 'function') {
          new Cmp(elem, this);
          $(elem).data('g-component-initialized', true);
        }
      }
    });
  }
}
